export const ORDER_DEADLINE_OLO = 'YYYYMMDD HH:mm';
export const DEADLINE_DATE_OLO = 'YYYYMMDD';
export const DEADLINE_DATE = 'MM/DD/YYYY';
export const DEADLINE_TIME = 'LT';
export const DEADLINE_FULL_DATE = 'MM/DD/YYYY LT';
